<template>
  <div class="row">
    <div class="col">
      <b-card>
        <b-tabs>
          <b-tab title="Debits">
           <debits/>
          </b-tab>
          <b-tab title="Credits">
             <credits/> 
          </b-tab>
        </b-tabs>

      </b-card>
    </div>
    
  </div>
</template>

<script>
import credits from "@/views/modules/parts/partCredits"
import debits from "@/views/modules/parts/partDebits"

export default {

  components:{
    credits,
    debits
  }

}
</script>

<style>

</style>